import * as tslib_1 from "tslib";
/**
 * New Business model. Contains all the required fields for a new business to be created
 */
import { Business } from './business.model';
var NewBusiness = /** @class */ (function (_super) {
    tslib_1.__extends(NewBusiness, _super);
    function NewBusiness() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewBusiness.prototype.serialize = function () {
        this.location = this.airport.location;
        var result = {
            name: this.name,
            facilityType: this.facilityType,
            addresses: this.serializeAddresses(),
            airports: [{
                    airportId: this.airport.airportId || null,
                    faaId: this.airport.faaId || null,
                    icaoId: this.airport.icaoId || null
                }],
            location: this.serializeLocation(),
            businessTags: this.businessTags,
            userAdded: this.userAdded,
            phone1: this.phone,
            fax: this.fax,
            webAddress: this.webAddress,
            emailAddress: this.email
        };
        result.addresses[0].country = 'US';
        return result;
    };
    return NewBusiness;
}(Business));
export { NewBusiness };
